app.service('partnerBar', function (loading, html) {
	var $self;

	function logoutPartner() {
		loading.redirect({
			href: '/konto-wyloguj.bhtml',
			soft: false
		});
	}
	function init() {
		$self = $('#top-operator-bar');
		if ($self.length && $('.partner-bar', $self).length) {
			html.add('partner-logged');
			$('.js-logout-partner', $self).click(function () {
				logoutPartner();
			});
		}
	}
	return {
		init
	};
});
